import {PromotedFeatureEnum} from "~/app/domains/onboarding/enums/promoted-feature.enums";
import {PromotedFeature} from "~/app/domains/onboarding/types/promoted-feature.type";
import {TRACKING_ACTIONS} from "~/app/shared/enums/tracking/matomo-action.enum";
import { VideoTypes } from "~/app/shared/enums/variables";

export const PROMOTED_FEATURES: PromotedFeature[] = [
    {
        id: PromotedFeatureEnum.RELEASE_26_6,
        popin: {
            title: 'promoted_features.release_26_6.title',
            slogan: 'promoted_features.release_26_6.slogan',
            explanations: [],
            video: {
                url: 'https://app.supademo.com/embed/cmo76vf9a001t250ji05c936t',
                type: VideoTypes.SUPADEMO
            },
            ctas: [
                {
                    icon: 'ui/action/symbols/check',
                    title: '',
                    action: null,
                    tracking: null
                }
            ]
        }
    },
    {
        id: PromotedFeatureEnum.TUTORIALS_VIDEO,
        popin: {
            title: 'promoted_features.tutorials_videos.title',
            slogan: 'promoted_features.tutorials_videos.slogan',
            illustration: '',
            explanations: [
                'promoted_features.tutorials_videos.explanations.sentence_1',
                'promoted_features.tutorials_videos.explanations.sentence_2'
            ],
            ctas: [
                {
                    icon: 'ui/action/symbols/check',
                    title: '',
                    action: null,
                    tracking: TRACKING_ACTIONS.TUTORIAL_VIDEOS
                }
            ]
        }
    }
]
